import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getFolderId, getMode } from "../redux/selectors";
import FolderEditorPanel from "./folderEditorPanel";
const mapStateToProps = (state) => ({
    mode: getMode(state),
    folderId: getFolderId(state)
});
const mapDispatchToProps = (dispatch) => ({
    onSaveFolder: (folder) => {
        dispatch(actionCreators.saveFolder(folder, []));
    },
    onClose: () => dispatch(actionCreators.closeForm())
});
export default connect(mapStateToProps, mapDispatchToProps)(FolderEditorPanel);
